<template>
  <div class="page_msg container">
    <div class="header_gruop page_width flex_sb">
      <div class="icon_home flex_center" @click="toBack()"><svg t="1729563443244" class="icon" viewBox="0 0 1024 1024"
          version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6080" id="mx_n_1729563443245" width="16" height="16">
          <path
            d="M398.912 513.152l377.28-384.256c27.904-28.416 27.904-74.432 0-102.784-27.84-28.352-73.024-28.352-100.8 0L247.808 461.504C233.792 475.776 226.88 494.464 226.944 513.152 226.88 531.84 233.792 550.464 247.808 564.736l427.584 435.392c27.84 28.352 73.024 28.352 100.8 0 27.904-28.352 27.904-74.368 0-102.656L398.912 513.152z"
            fill="#16181c" p-id="6081"></path>
        </svg></div>
      <div class="header_title">Privacy</div>
      <div></div>
    </div>

    <div class="scoller grid_content" :v-infinite-scroll="false" style="overflow:auto">
      <div class="service page_width">

        <p style="font-size: 18px;font-weight: bold;margin-bottom:20px;">Privacy Compliance Statement</p>
        <p style="margin-bottom:10px;">We are committed to protecting your personal data in accordance with the Personal
          Data (Privacy) Ordinance (Cap. 486, Laws of Hong Kong). Your information will be collected, processed and
          stored securely, and will only be used for purposes directly related to our services. We do not disclose your
          personal data to third parties except as required by law or with your explicit consent.</p>

        <p style="font-weight: bold;">1. Scope and Purpose of Information Collection</p>
        <p style="margin-bottom:10px;">When you use our game recharge services, we collect the following information for
          the corresponding purposes:</p>
        <li>When registering and logging in, we collect your email address. This information is used to create your
          account, perform login verification and ensure you can use our services normally.</li>
        <li>To complete your recharge transaction, we collect your recharge amount, payment channel details, transaction
          time, order status, real name and ID number. This information is used to accurately record transactions and
          ensure smooth order processing.</li>
        <li style="margin-bottom:10px;">We collect your device information (including device model, operating system
          version, device identifier, etc.) and operation logs (such as login time and recharge records). This helps
          safeguard account and transaction security, prevent fraud and unauthorized use, and maintain normal service
          operations.</li>

        <p style="font-weight: bold;">2. Information Sharing and Disclosure</p>
        <p style="margin-bottom:10px;">We solemnly undertake not to share, transfer or disclose your personal
          information arbitrarily. We will only process your personal information in the following circumstances:</p>
        <li>With your explicit consent;</li>
        <li>In accordance with applicable laws and regulations;</li>
        <li style="margin-bottom:10px;">When cooperating with payment institutions to provide recharge services, we
          clearly define the rights and obligations of all parties to ensure your personal information is not misused.
        </li>

        <p style="font-weight: bold;">3. Security Measures</p>
        <p style="margin-bottom:10px;">We implement a range of security measures, including but not limited to
          encryption technology for sensitive information and real-time risk monitoring systems, to protect your
          personal information. In the event of a personal data security incident, we will immediately activate our
          emergency plan, take remedial measures to minimize impact, and notify you promptly in accordance with legal
          requirements.</p>

        <p style="font-weight: bold;">4. User Rights</p>
        <p style="margin-bottom:10px;">You legally enjoy the following rights, which you may exercise through our
          official channels:</p>
        <li>Right of Access: You may access your personal information and recharge records.</li>
        <li>Right of Correction: If you believe your personal information is inaccurate, you may request us to correct
          it via the platform's profile edit function or by contacting customer service.</li>
        <li>Right of Deletion: Where required or permitted by law (such as unlawful processing or collection beyond
          stated purposes), you may request deletion of your personal information by contacting customer service.</li>
        <li>Right to Withdraw Consent: You may withdraw your consent to our collection and use of personal information
          at any time. Withdrawal may affect the use of certain services and can be processed by contacting customer
          service.</li>
        <li style="margin-bottom:10px;">Right to Account Termination: You have the right to terminate your account.
          After termination, we will delete or anonymize your personal information in accordance with applicable laws.
          You may contact customer service to process your request.</li>

        <p style="font-weight: bold;">5. Other Provisions</p>
        <li>Any changes to this Privacy Compliance Statement will be posted on the platform.</li>
        <li style="margin-bottom:40px;">If you have any questions, comments or suggestions, please contact our customer
          service at customer-service@playsave1st.com.</li>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
li {
  list-style-type: disc;
  /* 手动指定左侧内边距，为项目符号预留空间 */
  padding-left: 0px;
  /* 将项目符号放置在列表项内容区域内 */
  list-style-position: inside;
  /* 可选：添加外边距增加列表项间距 */
  /* margin-bottom: 10px; */
}
</style>